import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type TicketCommentRows = {
  label: string;
  id: vp.CreateTicketCommentId;
  require: boolean;
  type: 'textarea' | 'fileInput';
  preset: keyof vp.TextFieldPresets | undefined;
};

export const useBuildTicketCommentCreationRows = (): TicketCommentRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Tickets.Details' });

  return [
    {
      label: t('ticketCommentLabel'),
      id: vp.CreateTicketCommentId.TicketComment,
      require: true,
      preset: 'text',
      type: 'textarea',
    },
    {
      label: t('filesLabel'),
      id: vp.CreateTicketCommentId.Files,
      require: true,
      preset: 'text',
      type: 'fileInput',
    },
  ];
};
